import RatingView from './rating-view'

export default RatingView
